import { trackDigitalEvent } from '@sparknz/tracking';

import { MobilePlansDetails } from '../typings/plans';
import { getTrackingPromoDetails } from './getPromoDetails';

function buildProducts({
  isBusiness,
  planCardsProducts,
}: TrackSuccessfulAddToCartEventParameter) {
  return planCardsProducts.map((planCardsProduct) => {
    const {
      planDetails,
      planImages,
      price,
      promotions,
      contractTerm,
      productCharacteristics,
      dataLayerCategory,
    } = planCardsProduct;
    const priceValue = isBusiness
      ? price?.basePriceExcludingTax?.toString()
      : price?.basePrice?.toString();
    return {
      productInfo: {
        productID: planDetails?.planId,
        productName: planDetails?.planName,
        manufacturer: 'SPARK',
        sku: planDetails?.planId,
        productImage: planImages?.[0]?.thumbnailUrl || undefined,
      },
      category: {
        primaryCategory: dataLayerCategory || undefined,
      },
      attributes: {
        baseStore: isBusiness ? 'businessshop' : 'personalshop',
        categoryIdentifier: planDetails?.categoryIdentifiers?.join(','),
        contractTerm: contractTerm?.name || undefined,
        displayName: planDetails?.planName,
        itemBasePrice: priceValue,
        itemOneOffCost: price?.priceType === 'Recurring' ? '00.00' : priceValue,
        itemRecurringCost:
          price?.priceType === 'Recurring' ? priceValue : '00.00',
        isGSTIncluded: !isBusiness,
        paymentType: productCharacteristics?.balanceManagement || undefined,
        promoMessage: getTrackingPromoDetails(promotions).dealText || undefined,
        promoTag: getTrackingPromoDetails(promotions).marketingTag || undefined,
        segment: isBusiness ? 'BUSINESS' : 'CONSUMER',
      },
    };
  });
}

interface TrackSuccessfulAddToCartEventParameter {
  isBusiness: boolean;
  planCardsProducts: MobilePlansDetails;
}

export function trackSuccessfulAddToCartEvent({
  isBusiness,
  planCardsProducts,
}: TrackSuccessfulAddToCartEventParameter) {
  trackDigitalEvent({
    event: 'shop.addToCartAction',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Add to cart',
            eventAction: 'shop.addToCartAction',
          },
          attributes: {
            isSuccess: true,
          },
        },
      ],
      product: buildProducts({ isBusiness, planCardsProducts }),
    },
  });
}
